export const footerMoreLinks = {
  'qa-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.qa/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.qa/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.qa/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.qa/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.qa/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.qa/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'qa-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.qa/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.qa/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://www.wingie.qa/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.qa/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.qa/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.qa/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'qa-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.qa/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.qa/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://www.wingie.qa/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.qa/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.qa/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.qa/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'qa-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.qa/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.qa/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://www.wingie.qa/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.qa/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.qa/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.qa/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'qa-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.qa/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.qa/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://www.wingie.qa/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.qa/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.qa/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.qa/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'qa-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.qa/it/contact/', title: 'Contatti' },
        // { href: 'https://www.wingie.qa/it/faq/', title: 'Domande frequenti' },
        { href: 'https://www.wingie.qa/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.qa/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.qa/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.qa/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'qa-fr': [
    {
      title: 'Plus',
      items: [
        { href: 'https://www.wingie.qa/fr/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.qa/fr/faq/', title: 'Questions fréquemment posées' },
        { href: 'https://www.wingie.qa/fr/about-us/', title: 'À propos de nous' },
        { href: 'https://www.wingie.qa/fr/privacy/', title: 'Confidentialité' },
        { href: 'https://www.wingie.qa/fr/terms-and-conditions/', title: 'Conditions générales' },
        { href: 'https://www.wingie.qa/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'qa-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.qa/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.qa/pt/faq/', title: 'Perguntas frequentes' },
        { href: 'https://www.wingie.qa/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.qa/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.qa/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.qa/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'qa-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://www.wingie.qa/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.qa/ro/faq/', title: 'Întrebări frecvente' },
        { href: 'https://www.wingie.qa/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.qa/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.qa/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.qa/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'qa-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.qa/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.qa/pl/faq/', title: 'Często zadawane pytania' },
        { href: 'https://www.wingie.qa/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.qa/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.qa/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.qa/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'qa-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.qa/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.qa/lt/faq/', title: 'Dažnai užduodami klausimai' },
        { href: 'https://www.wingie.qa/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.qa/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.qa/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://www.wingie.qa/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'qa-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://www.wingie.qa/uz/contact/', title: 'Aloqa' },
        // { href: 'https://www.wingie.qa/uz/faq/', title: "Tez-tez so'raladigan savollar" },
        { href: 'https://www.wingie.qa/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.qa/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.qa/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.qa/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'qa-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.qa/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.qa/sr/faq/', title: 'Често постављана питања' },
        { href: 'https://www.wingie.qa/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.qa/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.qa/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.qa/sr/awards/', title: 'Наша признања' },
      ],
    },
  ],
  'qa-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.qa/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.qa/ky/faq/', title: 'Көп берилүүчү суроолор' },
        { href: 'https://www.wingie.qa/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.qa/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.qa/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.qa/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'qa-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.qa/tg/contact/', title: 'Алоқа' },
        // { href: 'https://www.wingie.qa/tg/faq/', title: 'Саволҳои зуд-зуд пурсида мешаванда' },
        { href: 'https://www.wingie.qa/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.qa/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.qa/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.qa/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'qa-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.qa/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.qa/kk/faq/', title: 'Жиі қойылатын сұрақтар' },
        { href: 'https://www.wingie.qa/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.qa/kk/privacy/', title: 'Құпиялық' },
        { href: 'https://www.wingie.qa/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.qa/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'qa-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.qa/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.qa/nl/faq/', title: 'Veelgestelde vragen' },
        { href: 'https://www.wingie.qa/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.qa/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.qa/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://www.wingie.qa/nl/awards/', title: 'Onze awards' },
      ],
    },
  ],
  'qa-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.qa/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.qa/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.qa/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.qa/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.qa/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.qa/ja/awards/' },
      ],
    },
  ],
  'qa-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.qa/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.qa/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.qa/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.qa/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.qa/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.qa/zh/awards/' },
      ],
    },
  ],
  'qa-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.qa/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.qa/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.qa/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.qa/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.qa/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.qa/ko/awards/' },
      ],
    },
  ],
  'qa-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.qa/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.qa/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.qa/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.qa/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.qa/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.qa/hi/awards/' },
      ],
    },
  ],
  'qa-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.qa/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.qa/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.qa/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.qa/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.qa/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.qa/ta/awards/' },
      ],
    },
  ],
  'qa-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.qa/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.qa/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.qa/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.qa/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.qa/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.qa/th/awards/' },
      ],
    },
  ],
  'qa-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.qa/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.qa/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.qa/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.qa/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.qa/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.qa/ur/awards/' },
      ],
    },
  ],
  'qa-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.qa/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.qa/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.qa/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.qa/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.qa/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.qa/ka/awards/' },
      ],
    },
  ],
}
